// Benefits.jsx
import "./Benefits.css";

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";

import BenefitItem from "./BenefitItem";
import useStore from "stores/Store";

import terms from "assets/images/microsite/benefits/terms.svg";
import qmark from "assets/images/microsite/benefits/question_mark.svg";

const IconContainer = styled.span`
    position: relative;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
    z-index: 2;

    img {
      width: 100%;
      height: 100%;
      opacity: 1;
      transition: opacity 0.3s ease;
    }
  `;

const Benefits = ({
  heading = "Benefits",
  benefitsData,
  tnc,
  faq,
  desktopImages,
  mobileImage,
  tncLink = "/tnc",
  isActive = true,
}) => {
  // const IconContainer = styled.span`
  //   position: relative;
  //   width: 24px;
  //   height: 24px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   margin-right: 1rem;
  //   z-index: 2;

  //   img {
  //     width: 100%;
  //     height: 100%;
  //     opacity: ${(props) => (props.isActive ? 1 : 0.3)};
  //     transition: opacity 0.3s ease;
  //   }
  // `;

  const [activeItems, setActiveItems] = useState(
    new Array(benefitsData.length).fill(false)
  );
  const { faqRef } = useStore();

  useEffect(() => {
    setActiveItems(new Array(benefitsData.length).fill(false));
  }, [benefitsData]);

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".benefit-item");
      const newActiveItems = [...activeItems];
      let hasChanged = false;

      elements.forEach((element, index) => {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight * 0.75;
        if (newActiveItems[index] !== isVisible) {
          newActiveItems[index] = isVisible;
          hasChanged = true;
        }
      });

      if (hasChanged) {
        setActiveItems(newActiveItems);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="benefits" className="about section about-section px-3 mx-sm-3">
      <div className="benefits container mx-auto" data-aos="fade-up">
        <Row>
          <div className="benefits-carousel">
            <div className="carousel-header pt-3 mx-3 w-50">
              <span className="benefits-heading">{heading}</span>
            </div>
            <div className="my-4">
              <Row className="justify-content-between gx-0">
                <Col
                  lg={6}
                  xs={12}
                  className="gy-5 desktop"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <Container>
                    {/* {desktopImages.map((row, rowIndex) => ( */}
                    <Row
                    // key={rowIndex}
                    // className={`align-items-${
                    //   rowIndex === 0
                    //     ? "end"
                    //     : rowIndex === 1
                    //     ? "center"
                    //     : "start"
                    // } justify-content-center my-1`}
                    >
                      {/* {row.map((image, index) => ( */}
                      <Col
                        // key={index}
                        // xl={
                        //   rowIndex === 0
                        //     ? index === 0
                        //       ? 3
                        //       : 4
                        //     : rowIndex === 1
                        //     ? index === 0
                        //       ? 8
                        //       : 4
                        //     : index === 0
                        //     ? 4
                        //     : 7
                        // }
                        className="banner-image-container"
                        // data-aos={`flip-${index % 2 === 0 ? "left" : "right"}`}
                        data-aos-delay="200"
                      >
                        <img
                          src={desktopImages}
                          // src={image} to be used in the next release
                          className="banner-image"
                          alt=""
                        />
                      </Col>
                      {/* ))} */}
                    </Row>
                    {/* ))} */}
                    {/* <Row>
                      <Col
                        xl={12}
                        className="g-5 table-desktop align-items-start"
                        data-aos-delay="200"
                      >
                        <Link className="link_benefits" to={tncLink}>
                          {tnc}{" "}
                        </Link>
                      </Col>
                    </Row> */}
                  </Container>
                </Col>

                <Col
                  lg={6}
                  className="flex align-items-center mobile"
                  data-aos="flip-up"
                  data-aos-delay="200"
                >
                  <img src={mobileImage} style={{ width: "100%" }} alt="" />
                </Col>

                <Col
                  lg={6}
                  xs={12}
                  className="gy-5"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="position-relative d-flex flex-1 flex-column gap-6 py-1 px-1 md:gap-10">
                    <div className="progress-wrap position-absolute left-0 w-9 overflow-hidden">
                      <div
                        className="progress-line position-absolute left-0 top-0 z-0  w-100"
                        style={{
                          transform: `scaleY(${
                            activeItems.filter(Boolean).length /
                            activeItems.length
                          })`,
                          transformOrigin: "top",
                          transition: "transform 0.5s ease",
                          backgroundColor: "#221AFB",
                        }}
                      />
                    </div>

                    {benefitsData?.map((benefit, index) => (
                      <div className="benefit-item" key={index}>
                        <BenefitItem
                          {...benefit}
                          isActive={activeItems[index]}
                        />
                      </div>
                    ))}
                  </div>

                  <Col
                    // md={12}
                    className="gy-5"
                    // data-aos-delay="200"
                    lg={12}
                    xs={12}
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="benefit-footer-container">
                      {faq && (
                        <div className="benefit-content-container">
                          <IconContainer isActive={isActive}>
                            <img src={qmark} alt="" />
                          </IconContainer>
                          <span
                            className="link_benefits"
                            onClick={() => {
                              if (faqRef.current) {
                                const offset = 400; // Adjust this value as needed
                                const topPosition =
                                  faqRef.current.getBoundingClientRect().top +
                                  window.pageYOffset -
                                  offset;
                                window.scrollTo({
                                  top: topPosition,
                                  behavior: "smooth",
                                });
                              }
                            }}
                          >
                            {faq}{" "}
                          </span>
                        </div>
                      )}
                      {faq && <span className="mx-3 vertical-line">|</span>}
                      <div className="benefit-content-container">
                        <IconContainer isActive={isActive}>
                          <img src={terms} alt="" />
                        </IconContainer>
                        <Link className="link_benefits" to={tncLink}>
                          {tnc}{" "}
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Col>
              </Row>
            </div>
          </div>
        </Row>
      </div>
    </section>
  );
};

export default Benefits;
